import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {STYLE_GRID_ITEM_SPACING} from "../../Constants";
import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {styles} from "../../components/styles";
import {getSavedSpreadsheetsOptions} from "./DataGridView";
import SavedSpreadsheet from "./SavedSpreadsheet";

class SpreadsheetSelectionDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saved : []
        };
    }

    componentDidMount() {
        getSavedSpreadsheetsOptions(this.props.workspace).then(options => this.setState({saved: options}));
    }

    renderDialog = () => {
        const {saved, selected} = this.state;
        const {theme, workspace} = this.props;
        return <Dialog
            aria-labelledby="Select"
            open={true}
            fullWidth={true}
            maxWidth={'xs'}
            datatest={'selectDialog'}
        >
            <DialogTitle id="form-dialog-title">Select</DialogTitle>
            <DialogContent>
                <div style={{height: '100px'}}>
                    <SavedSpreadsheet
                        label={'Search & Select'}
                        workspace={workspace}
                        options={saved || []}
                        value={selected}
                        onChange={(event, newValue, reason) => {
                            this.setState({selected: newValue});
                        }}

                    ></SavedSpreadsheet>
                </div>
            </DialogContent>
            <DialogActions>
                <Button datatest={'cancelButton'} variant={"outlined"} onClick={() => {
                    this.props.onCancel();
                }} color="secondary">Cancel</Button>
                <Button disabled={!selected} datatest={'selectButton'}
                        style={{marginLeft: theme.spacing(STYLE_GRID_ITEM_SPACING)}} variant={"contained"}
                        color="secondary" onClick={() => {
                            this.props.onSelect(selected);
                }}>Open</Button>
            </DialogActions>
        </Dialog>;
    }

    render() {
        return this.renderDialog();
    }
}

SpreadsheetSelectionDialog.propTypes = {
    workspace: PropTypes.object,
    onSelect: PropTypes.func,
    onCancel: PropTypes.func
};

export default withStyles(styles, {withTheme: true})(SpreadsheetSelectionDialog);
